import doNothing from '@opsbase/lib-general/utils/doNothing';
import i18n from '@opsbase/lib-i18n';
import useOrgTemplateUpdate from '@opsbase/react-gql-hooks/orgtemplate/useOrgTemplateUpdate';
import useCallforward from '@opsbase/react-hooks/useCallforward';
import useCss from '@opsbase/web-css/useCss/useCss';
import Card from '@opsbase/web-layout/Card/Card';
import Horizontal from '@opsbase/web-layout/Horizontal';
import Pane from '@opsbase/web-layout/Pane';
import Vertical from '@opsbase/web-layout/Vertical';
import OpTypePicker from '@opsbase/web-pickers/OpTypePicker/OpTypePicker';
import TextFieldWithStateAndBlur from '@opsbase/web-textfield/TextFieldWithStateAndBlur';
import Text from '@opsbase/web-ui/Text';
import React, { useCallback, useMemo } from 'react';
import OptionsSettingsSection from '../opdefinition/settingssections/OptionsSettingsSection';
import ScoringSettingsSection from '../opdefinition/settingssections/ScoringSettingsSection';
import WhoSettingsSection from '../opdefinition/settingssections/WhoSettingsSection';
const makeMyClasses = () => ({
    container1: {
        maxWidth: '45%',
    },
    container2: {
        overflow: 'scroll',
    },
});
export function OrgTemplateEditSettingsTab(props) {
    const { template } = props;
    const updateOrgTemplate = useOrgTemplateUpdate();
    const myCss = useCss(makeMyClasses);
    const doUpdate = useMemo(() => patch => {
        updateOrgTemplate({
            id: template.id,
            patch,
        }).catch(doNothing);
    }, [template.id, updateOrgTemplate]);
    const handleFieldUpdate = useCallforward(field => value => {
        doUpdate({ [field]: value });
    }, [doUpdate]);
    const handleChangeOpType = useCallback(v => {
        doUpdate({ type: v });
    }, [doUpdate]);
    const handleUpdatePatch = useCallback(patch => {
        var _a, _b, _c, _d, _e, _f;
        if ((_a = patch === null || patch === void 0 ? void 0 : patch.places) === null || _a === void 0 ? void 0 : _a.length) {
            patch.places = patch.places.map(p => ({ id: p.id }));
        }
        if ((_b = patch === null || patch === void 0 ? void 0 : patch.teams) === null || _b === void 0 ? void 0 : _b.length) {
            patch.teams = patch.teams.map(p => ({ id: p.id }));
        }
        if ((_c = patch === null || patch === void 0 ? void 0 : patch.positions) === null || _c === void 0 ? void 0 : _c.length) {
            patch.positions = patch.positions.map(p => ({ id: p.id }));
        }
        if ((_d = patch === null || patch === void 0 ? void 0 : patch.approvalStaff) === null || _d === void 0 ? void 0 : _d.length) {
            patch.approvalStaff = patch.approvalStaff.map(p => ({ id: p.id }));
        }
        if ((_e = patch === null || patch === void 0 ? void 0 : patch.approvalTeams) === null || _e === void 0 ? void 0 : _e.length) {
            patch.approvalTeams = patch.approvalTeams.map(p => ({ id: p.id }));
        }
        if ((_f = patch === null || patch === void 0 ? void 0 : patch.approvalStaff) === null || _f === void 0 ? void 0 : _f.length) {
            patch.approvalPositions = patch.approvalPositions.map(p => ({ id: p.id }));
        }
        updateOrgTemplate({
            id: template.id,
            patch,
        }).catch(doNothing);
    }, [template, updateOrgTemplate]);
    return useMemo(() => (React.createElement(Horizontal, { scroll: true },
        React.createElement(Vertical, { scroll: true, gutter: true, classes: { root: myCss.container1 } },
            React.createElement(Vertical, { scroll: true, padding: true },
                React.createElement(Horizontal, { style: { paddingBottom: 8 }, gutter: true, justify: "flex-start", alignItems: "flex-bottom" },
                    React.createElement(Text, { variant: "h1" }, i18n.t('about'))),
                React.createElement(Card, { padding: true },
                    React.createElement(Vertical, { paddingY: true, gutter: true },
                        React.createElement(Pane, null,
                            React.createElement(Text, null, i18n.t('template-description-enter')),
                            React.createElement(TextFieldWithStateAndBlur, { white: true, fullWidth: true, placeholder: i18n.t('template-description'), value: template.description, onBlur: handleFieldUpdate('description') })),
                        React.createElement(Pane, null,
                            React.createElement(Text, { style: { marginTop: 16 } }, i18n.t('name-of-optype-label')),
                            React.createElement(OpTypePicker, { fullWidth: true, noMargin: true, white: true, value: template.type, onChange: handleChangeOpType }))))),
            React.createElement(Pane, null,
                React.createElement(ScoringSettingsSection, { definition: template, isEditable: true, onChange: handleUpdatePatch }))),
        React.createElement(Vertical, { scroll: true, gutter: true, classes: { root: myCss.container2 } },
            React.createElement(OptionsSettingsSection, { definition: template, isEditable: true, onChange: handleUpdatePatch }),
            React.createElement(WhoSettingsSection, { definition: template, isEditable: true, onChange: handleUpdatePatch })))), [handleChangeOpType, handleFieldUpdate, handleUpdatePatch, myCss, template]);
}
export default OrgTemplateEditSettingsTab;
